import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// Initialize Firebase
var config = {
    apiKey: "AIzaSyBEw18OwgYvggigIMv20_bWznpd_IrVg7Y",
    authDomain: "presser-app.firebaseapp.com",
    databaseURL: "https://presser-app.firebaseio.com",
    projectId: "presser-app",
    storageBucket: "presser-app.appspot.com",
    messagingSenderId: "1028084279929"
  };
  firebase.initializeApp(config);
  firebase.firestore().settings({});

  export default firebase;